import type { RichLead } from '../../lead.popup/types';
import type { UnitInterestedLead } from '../../services/api';
import type { AdditionalContact, Lead } from '../../types';

import React from 'react';
import { Trans } from '@lingui/macro';

import { LeadName } from '../../lead.popup/common';
import { UnitLeadDetails } from './UnitLeadDetails';

export type UnitLeadHeadingProps = {
  lead: Lead | RichLead | UnitInterestedLead | AdditionalContact;
  isInResale?: boolean;

  /**
   * Whether it is allowed to pick this lead to work with
   */
  allowAddToClipboard?: boolean;

  /**
   * Apply additional logic in case this is not a Lead but it's additional contacts
   */
  isAdditionalContact?: boolean;
};

export function UnitLeadHeading({
  lead,
  isInResale,
  allowAddToClipboard,
  isAdditionalContact,
}: UnitLeadHeadingProps) {
  const [isCollapsed, setIsCollapsed] = React.useState(true);

  return (
    <>
      <div
        className="b-contacts__container"
        onClick={() => {
          setIsCollapsed((collapsed) => !collapsed);
        }}
      >
        {isInResale && (
          <div>
            <p>
              <Trans id="unit.popup.unitdeallead.current.owner">
                Current owner:
              </Trans>
            </p>
          </div>
        )}
        <div className="b-contacts__name g-truncate" style={{ width: 300 }}>
          <LeadName name={lead.name} />
        </div>
        {!!lead.note && (
          <span className="b-contacts__note g-truncate">{lead.note}</span>
        )}
      </div>

      {!isCollapsed && (
        <UnitLeadDetails
          lead={lead}
          allowAddToClipboard={allowAddToClipboard}
          isAdditionalContact={isAdditionalContact}
        />
      )}
    </>
  );
}
